import React, { Component } from 'react';
import Table from '../../../../../components/_table/Table/Table';
import Button from '../../../../../components/Button';
import Panel from '../../../../../components/outline/Panel';
import { TAG_GROUP_CREATE_URL_PATH } from '../../../../../constants/service/common/urlConstants';
import { comparePrePropsAndNextProps, reDirectPage } from '../../../../../lib/common';
import { columns } from './columns';
import './TagGroupList.scss';

class TagGroupList extends Component {
  /**
   *  Component 의 변경되는 props 와 state 가 있을 경우에만,
   *  render 메소드를 호출할 수 있도록 함
   */
  shouldComponentUpdate = (nextProps) => {
    return comparePrePropsAndNextProps([[nextProps, this.props]]);
  };

  render() {
    const { tagList, sortOption, pagination, getList } = this.props;

    return (
      <div className="tag-group-list">
        <Panel>
          <div className="panel-header">
            <div className="title">태그 그룹 리스트</div>
            <div className="btn-area">
              <Button
                color="primary"
                text="태그 그룹 생성하기"
                onClick={() => reDirectPage({ path: TAG_GROUP_CREATE_URL_PATH })}
              />
            </div>
          </div>

          <div className="panel-body">
            <Table
              columns={(utils) =>
                columns({
                  ...utils,
                })
              }
              rowKey={(record) => record.id}
              sortOption={sortOption}
              pagination={pagination}
              list={tagList}
              size="small"
              scroll={{ x: true }}
              bordered={true}
              getList={getList}
            />
          </div>
        </Panel>
      </div>
    );
  }
}

export default TagGroupList;
